import {ProtocolCommand} from '../../../service-model/protocol-command.interface';
import {SHELL_PROTOCOL_OPERATIONS_NS} from '../shell-protocol-namespace.const';

export class AllocateUnaccountedPosition implements ProtocolCommand {
  constructor(
    public readonly terminalId: string,
    public readonly accountId: string,
    public readonly ticker: string
  ) {
  }

  getOperationName(): string {
    return `${SHELL_PROTOCOL_OPERATIONS_NS}.AllocateUnaccountedPosition`;
  }
}
